import { FieldProps, FieldArray } from "formik";
import React from "react";
import { Button } from "../../..";
import IconButton from "../../../IconButton";
import Error from "../../Error";

type TextArrayTypes = "text" | "email" | "number";

export interface TextArrayProps<T = any> {
	field?: FieldProps<string[], any>["field"];
	form?: FieldProps["form"];
	innerRefs?: React.RefObject<T>[];
	id: string;
	name: string;
	onKeyPress?: (e: React.KeyboardEvent) => void;
	ref?: React.RefObject<any>;
	type?: TextArrayTypes;
	value?: string;
	[key: string]: any;
	editInline?: boolean;
	className?: string;
	itemLabel?: string;
	min?: number;
}

const TextArray: React.FC<TextArrayProps> = ({
	type = "text",
	field,
	form,
	className,
	editInline,
	id,
	name,
	innerRefs,
	itemLabel = "Item",
	min = 0,
	...props
}) => {
	if (form?.status?.bag?.readonly) {
		return <div className="form-readonly-value">{(field && field.value) || props.value || ""}</div>;
	}

	return (
		<FieldArray
			name={(field && field.name) || name}
			render={(arrayHelpers) => (
				<div>
					{field?.value.map((val, index) => {
						//@ts-ignore
						const errorValue = form?.errors[`${(field && field.name) || name}`]?.[index];
						return (
							<div key={index} className="text-array-row m-bottom-sm">
								<input
									id={`${(field && field.name) || name}.${index}`}
									type={type}
									{...field}
									ref={innerRefs?.[index]}
									name={`${(field && field.name) || name}.${index}`}
									value={val || ""}
									className={`${className ? className : ""}${
										editInline ? "edit-inline" : ""
									} text-array-input`}
									{...props}
								/>
								{!min ||
									((field?.value.length ?? 0) > min && (
										<IconButton
											icon="minus"
											ariaLabel={`Remove ${itemLabel}`}
											onClick={(evt) => {
												evt.preventDefault();
												evt.stopPropagation();
												arrayHelpers.remove(index);
											}}
										/>
									))}
								{!!errorValue && <Error>{errorValue}</Error>}
							</div>
						);
					})}

					<Button
						purpose="light"
						aria-label={`Add ${itemLabel}`}
						classes="btn-sm"
						onClick={(evt) => {
							evt.preventDefault();
							evt.stopPropagation();
							arrayHelpers.push("");
						}}
					>
						+ Add {itemLabel}
					</Button>
				</div>
			)}
		/>
	);
};

export default TextArray;
